export default __webpack_public_path__ + "static/media/N_wdt_c_cap_5.0a07ea38.mp3";